import zod from 'zod';

export const IvsDeviceAvailableEvents = zod.enum([
  'CROSSLINEDETECTION',
  'CROSSREGIONDETECTION',
  'PASTEDETECTION',
  'LEFTDETECTION',
  'STAYDETECTION',
  'WANDERDETECTION',
  'MOVEDETECTION',
  'RIOTERDETECTION',
  'FIGHTDETECTION',
  'CAMERACOVERDDETECTION',
  'VIDEOABNORMALDETECTION',
  'ABNORMALRUNDETECTION',
  'ALARM_MOTIONDETECT',
  'ALARM_LOCALALARM',
  'WORKCLOTHES_DETECT',
]);

export const IvsEditionFormSchema = zod.object({
  // availableEvents: LprDeviceAvailableEvents,
});
// .merge(DeviceFormSchema);

export const IvsDeviceConfigEditionFormSchema = zod.object({
  snapTimer: zod.string().optional().nullable(),
  isLpr: zod.boolean().optional(),
  isSnapCam: zod.boolean().optional(),
  telegramIds: zod.array(zod.string()).optional(),
  whatsAppNumbers: zod.array(zod.string()).optional(),
  smtpIntegrationId: zod.number().optional().nullable(),
  emailAddresses: zod.array(zod.string().max(254).email()).optional(),
  isNotifyLogEvent: zod.boolean(),
});
